import { useState } from 'react';
import { Layout } from 'antd';
import SidebarContent from './SidebarContent';

const { Sider } = Layout;

const style = {
  overflow: 'auto',
  height: '100vh',
  left: 0,
  top: 0,
  bottom: 0,
  zIndex: 1000,
  borderTopRightRadius: 20,
  transition: 'all 0.2s ease, background 0.3s ease',
};

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(true);

  return (
    <Sider
      trigger={null}
      width={collapsed ? 70 : 205}
      style={{ position: 'fixed', ...style }}
      breakpoint="lg"
      onMouseEnter={() => setCollapsed(false)}
      onMouseLeave={() => setCollapsed(true)}
      collapsed={collapsed}
      collapsible
      collapsedWidth={70}
      className='sidebar'
    >
      <SidebarContent collapsed={collapsed} onClose={() => { }} />
    </Sider>
  );
};

export default Sidebar;
